import { render } from "./ConfigurationRestorePointBox.vue?vue&type=template&id=3157b80d&scoped=true"
import script from "./ConfigurationRestorePointBox.vue?vue&type=script&lang=js"
export * from "./ConfigurationRestorePointBox.vue?vue&type=script&lang=js"

import "./ConfigurationRestorePointBox.vue?vue&type=style&index=0&id=3157b80d&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3157b80d"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QList,QItemSection,QItemLabel});qInstall(script, 'directives', {ClosePopup});
